<template>
  <b-dropdown
    id="actionButtonProduct"
    size="lg"
    toggle-class="text-decoration-none"
    no-caret
    dropleft
  >
    <template #button-content>
      <i class="green fas fa-bars"></i>
    </template>
    <b-dropdown-header>
      <strong>{{ $lang.Common.PlaceholderSelect }}</strong>
    </b-dropdown-header>
    <b-dropdown-item @click="$emit('ActionProduct', product, productSituation.ATIVO)" v-if="product.situacao != productSituation.ATIVO">
      <i class="fas fa-undo-alt"></i>
      Resetar</b-dropdown-item
    >
    <b-dropdown-item @click="$emit('ActionProduct', product, productSituation.GANHO)" v-if="product.situacao != productSituation.GANHO">
      <i class="green fas fa-check"></i>
      Ganhar</b-dropdown-item
    >
    <b-dropdown-item @click="$emit('ActionProduct', product, productSituation.PERDIDO)" v-if="product.situacao != productSituation.PERDIDO">
      <i class="red fas fa-times"></i>
      Perder</b-dropdown-item
    >
    <b-dropdown-item @click="$emit('ActionProduct', product, 'DELETAR')">
      <i class="black fas fa-trash-alt"></i>
      Deletar</b-dropdown-item
    >
  </b-dropdown>
</template>
<script>
import productSituation from '@/enums/enumProductSituation.js'

export default {
  name: 'ActionButtonProduct',
  props: {
    product: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data () {
    return {
      productSituation: productSituation
    }
  }
}
</script>
<style lang="scss">
  #actionButtonProduct {
    .green {
      color: #04a791;
    }
    .red {
      color: red;
    }
    .black {
      color: #000;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/private/crm/details/product/components/ActionButtonProduct.vue